export interface MissingResp {
  error: string
  missing: string[]
  message: string
  links?: Record<string, string>
}

const FALLBACK_MESSAGE =
  'Client data incomplete — complete Dream Job, Clifton Strengths, and Resume first.'

interface GenerateRejection {
  message?: string
  details?: Partial<MissingResp>
}

// apiCall's message is the server's short error code ("Missing client data"); the
// sentence naming what is missing and the links to fix it travel in the body, which
// ApiError keeps as `details`.
export function missingFromRejection(rejection: GenerateRejection): MissingResp {
  const details = rejection.details
  return {
    error: 'missing',
    missing: Array.isArray(details?.missing) ? details.missing : [],
    message: details?.message || rejection.message || FALLBACK_MESSAGE,
    links: details?.links,
  }
}
